import { render, staticRenderFns, recyclableRender, components } from "./uni-nav-bar.vue?vue&type=template&id=4afea59e&scoped=true&"
var renderjs
import script from "./uni-nav-bar.vue?vue&type=script&lang=js&"
export * from "./uni-nav-bar.vue?vue&type=script&lang=js&"
import style0 from "./uni-nav-bar.vue?vue&type=style&index=0&id=4afea59e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!C:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afea59e",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/uni-nav-bar/uni-nav-bar.vue"
export default component.exports